export {
  addResourceNote,
  mapFhirToResourceNote,
  mapResourceNoteToFhir,
} from './mapping';
export type { ResourceNote } from './schema';
export { ResourceNoteSchema } from './schema';
